import { render, staticRenderFns } from "./xy_report.vue?vue&type=template&id=53c781d2&scoped=true"
import script from "./xy_report.vue?vue&type=script&lang=js"
export * from "./xy_report.vue?vue&type=script&lang=js"
import style0 from "./xy_report.vue?vue&type=style&index=0&id=53c781d2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53c781d2",
  null
  
)

export default component.exports